import axios from 'axios';

export const HTTP = axios.create({

    baseURL: process.env.ROOT_API, //http://vvg.salesintranet.com/api/v1
    headers: {
      'Content-Type': 'application/json',
    }
});
export const HTTPGUZZLE = axios.create({

    baseURL: "https://www.velocitytruckcenters.com", //http://vvg.salesintranet.com/api/v1
    headers: {
      'Content-Type': 'application/json',
    }
});


// WEBPACK FOOTER //
// ./src/http-common.js